module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.674f50d2.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.eot
// module id = 939
// module chunks = 5